var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasModules
    ? _c("div", [
        _vm.title
          ? _c("h2", { staticClass: "content-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("section", { staticClass: "dashboard-list" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm._l(_vm.modules, function (module, index) {
                return [
                  module.route
                    ? [
                        _c(
                          "router-link",
                          {
                            key: index,
                            class: _vm.moduleClass,
                            attrs: {
                              to: {
                                name: module.route,
                                params: {
                                  appCode: _vm.formatRouteAppCode(module.code),
                                },
                              },
                            },
                          },
                          [
                            _c("dashboard-item", {
                              attrs: {
                                module: module,
                                config: _vm.dashboardConf,
                                showImage: _vm.showImage,
                                showIcon: _vm.showIcon,
                                showNotifications: _vm.showNotifications,
                                showNotificationsIcon:
                                  _vm.showNotificationsIcon,
                                showNotificationsArrow:
                                  _vm.showNotificationsArrow,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : module.url
                    ? [
                        _c(
                          "a",
                          {
                            key: index,
                            class: _vm.moduleClass,
                            attrs: { href: module.url, target: "_blank" },
                          },
                          [
                            _c("dashboard-item", {
                              attrs: {
                                module: module,
                                config: _vm.dashboardConf,
                                showImage: _vm.showImage,
                                showIcon: _vm.showIcon,
                                showNotifications: _vm.showNotifications,
                                showNotificationsIcon:
                                  _vm.showNotificationsIcon,
                                showNotificationsArrow:
                                  _vm.showNotificationsArrow,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c("dashboard-item", {
                          key: index,
                          attrs: {
                            listClass: _vm.moduleClass,
                            module: module,
                            config: _vm.dashboardConf,
                            showImage: _vm.showImage,
                            showIcon: _vm.showIcon,
                            showNotifications: _vm.showNotifications,
                            showNotificationsIcon: _vm.showNotificationsIcon,
                            showNotificationsArrow: _vm.showNotificationsArrow,
                          },
                        }),
                      ],
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.showButtonMore
            ? _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "btn btn-main btn-md btn-responsive mx-0 my-3 my-sm-0",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.showMore.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("ver mais")]
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }